import { types } from '../config'
import initialState from '../state'

export const SET_TYPE = 'export-tool/types/set-type'
export const FETCH_TYPES = 'export-tool/types/fetch-types'

export default function reducer(state = {...initialState.types}, action = {}) {
  const newState = {...state}
  switch (action.type) {
    case SET_TYPE:
      newState.selected = action.payload.type
      return newState
      break

    case FETCH_TYPES:
      newState.fetched = true
      newState.list = types
      return newState
      break

    default:
      return state
      break
  }
}

export function setType(type) {
  return {
    type: SET_TYPE,
    payload: {
      type
    }
  }
}

export function fetchTypes(type) {
  return {
    type: FETCH_TYPES,
    payload: null
  }
}




// WEBPACK FOOTER //
// ./ducks/types.js